<template>
  <div class="transaction-details">
    <div class="amount">
      <span>{{ getTransactionAmount(transaction) }}</span>
      <span class="nis-currency">₪</span>
    </div>
    <div class="business-name">{{ transaction.businessName }}</div>
    <div class="date">{{ formatDate(transaction.transactionDate) }}</div>
    <div class="account">{{ getTransactionAccount(transaction) }}</div>
  </div>
</template>

<script>
import TransactionDisplayUtils from '../../../../generic-components/TransactionDisplayUtils.vue';

export default {
  name: 'TransactionDetails',
  mixins: [TransactionDisplayUtils],
  props: {
    transaction: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../../../../../../../../../node_modules/base-ui/src/scss/riseup-colors';

  .transaction-details {
    .amount {
      font-size: 50px;
      line-height: 50px;
      font-weight: bold;
      margin-bottom: 10px;

      .nis-currency {
        font-size: 24px;
        line-height: 30px;
        font-weight: bold;
      }
    }

    .date, .business-name, .account {
      font-size: 16px;
      line-height: 22px;
      margin-bottom: 4px;
    }

    .business-name {
      font-weight: bold;
    }
  }

</style>
